/*
 * WHICH REFERENCES ON A PANEL CAN BE LOOKED UP SOMEWHERE ELSE.
 *
 * `panel.reportsNumbering` tells a reader that the numbers beside these reports are the digitiser's
 * own sequence and will not match a citation from anywhere else. That is true of the Sunni
 * collections and **it is false of the Shia ones**, and the note shipped unconditional for a day.
 *
 *   Bukhari 152          a flat number, and Islam Ware's own. Measured against two independent
 *                        digitisations — Athar, and the Leeds/King Saud corpus in sunnah.com's
 *                        numbering — 1,972 reports matched by TEXT and four of their numbers agreed
 *   al-Kāfī 1:1:1:1      volume, book, chapter, ḥadīth. From Thaqalayn, in al-Kāfī's own eight-volume
 *                        division, and a reader can carry it to any edition
 *   Sermon 5:2           Nahj al-Balāgha as everyone cites it — sermon, letter or saying, and the
 *                        sayings run to 480, which is the number there are
 *
 * ─────────────────────────────────────────────────────────────────────────────────────
 * THIS TESTS THE REFERENCE'S SHAPE, AND THAT IS THE PROPERTY ITSELF RATHER THAN A PROXY FOR IT.
 *
 * The tempting alternative is a list of Sunni collection names. That would be a second copy of
 * something the corpora already state, kept in step by hope — and it would answer the wrong
 * question, because what makes a citation unusable is not which shelf it sits on but that **a bare
 * ordinal claims to be a lookup key and is not one**. A hierarchical reference states its own
 * structure and can be checked against any printing; a flat one cannot, whoever produced it.
 *
 * So a shelf that arrived tomorrow with flat numbering would be covered without anybody adding it
 * to a list, and a Sunni collection that gained a book-and-chapter address would stop being warned
 * about on the day it did.
 */

/**
 * Whether a reference is a bare ordinal — a collection name and a number, nothing else.
 *
 * The digits must end the string: `Bukhari 152` yes, `al-Kāfī 1:1:1:1` no, `Sermon 5:2` no.
 */
export const isBareOrdinal = (ref: string): boolean => /^\D+\s\d+$/.test(ref.trim());

/** Whether any reference shown carries a bare ordinal, and so needs the numbering note. */
export const needsNumberingNote = (refs: readonly string[]): boolean => refs.some(isBareOrdinal);
